import { keysToSnakeCaseDeep } from '@agro1desenvolvimento/utils-js';
import { TratamentoSementes, TratamentoSementesToSave } from '../@types';
import aqilaApi from './aqila-api';

export type FilterTratamentoSementesType = {
  safraId?: number;
  propriedadeId?: number;
};

class TratamentosSementes {
  private readonly endpoint = 'v1/recomendacoes_tratamento_sementes';

  async create(record: TratamentoSementesToSave) {
    await aqilaApi.post(this.endpoint, keysToSnakeCaseDeep(record));
  }

  async update(record: TratamentoSementesToSave & { id: string }) {
    await aqilaApi.patch(
      `${this.endpoint}/${record.id}`,
      keysToSnakeCaseDeep(record),
    );
  }

  async list(params: FilterTratamentoSementesType = {}) {
    const { data } = await aqilaApi.get<TratamentoSementes[]>(this.endpoint, {
      params: keysToSnakeCaseDeep(params),
    });

    return data;
  }

  async find(id: string) {
    const { data } = await aqilaApi.get<TratamentoSementes>(
      `${this.endpoint}/${id}`,
    );

    return data;
  }

  async delete(id: string) {
    await aqilaApi.delete(`${this.endpoint}/${id}`);
  }
}

export default new TratamentosSementes();
